import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Loader2, Images } from "lucide-react";

const Catalogo = () => {
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [lightboxIndex, setLightboxIndex] = useState(-1);
  
  //  Estado para la nueva imagen de cabecera
  const [heroImageUrl, setHeroImageUrl] = useState("https://images.unsplash.com/photo-1555992336-03a23c1dcb72");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      // Pedimos todos los datos al mismo tiempo para optimizar
      const [categoriesRes, imagesRes, heroImageRes] = await Promise.all([
        supabase.from("event_categories").select("*").order("name"),
        supabase.from("gallery_images").select("*").order("created_at", { ascending: false }),
        supabase.from("site_settings").select("value").eq("key", "catalogo_hero_image_url").single()
      ]);

      if (categoriesRes.error || imagesRes.error) {
        console.error("Error fetching data:", categoriesRes.error || imagesRes.error);
      } else {
        setCategories(categoriesRes.data || []);
        setImages(imagesRes.data || []);
        if (heroImageRes.data?.value) {
          setHeroImageUrl(heroImageRes.data.value);
        }
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  // Filtrar imágenes según categoría seleccionada
  const filteredImages =
    selectedCategory === "all"
      ? images
      : images.filter((image) => image.category_id === selectedCategory);

  const slides = filteredImages.map((img) => ({
    src: img.image_url,
    title: img.title,
  }));

  return (
    <div className="bg-white">
      {/* Hero con imagen dinámica */}
      <div className="relative bg-gray-900">
        <img
          src={heroImageUrl} // Se usa la imagen del estado
          alt="Eventos"
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="relative z-10 text-center py-28 px-6">
          <Images className="mx-auto mb-6 text-orange-400 w-14 h-14" />
          <h1 className="text-5xl font-extrabold text-white tracking-wide">
            Catálogo de Eventos
          </h1>
          <p className="mt-4 text-xl text-gray-200">
            Cada evento es una obra de arte única.
          </p>
        </div>
      </div>

      {/* Filtros */}
      <div className="mt-10 flex justify-center flex-wrap gap-3 px-6">
        <button
          onClick={() => setSelectedCategory("all")}
          className={`px-5 py-2 text-sm rounded-full font-semibold transition shadow ${
            selectedCategory === "all"
              ? "bg-gradient-to-r from-orange-500 to-red-500 text-white"
              : "bg-white text-gray-700 hover:bg-gray-200"
          }`}
        >
          Todos
        </button>
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => setSelectedCategory(category.id)}
            className={`px-5 py-2 text-sm rounded-full font-semibold transition shadow ${
              selectedCategory === category.id
                ? "bg-gradient-to-r from-orange-500 to-red-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-200"
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Galería (sin cambios) */}
      <div className="mt-12 max-w-7xl mx-auto px-6 pb-12">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Loader2 className="animate-spin text-orange-500" size={48} />
          </div>
        ) : filteredImages.length === 0 ? (
          <p className="text-center text-gray-500">
            No hay imágenes en esta categoría.
          </p>
        ) : (
          <div
            className={`grid gap-6 ${
              selectedCategory === "all"
                ? "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5"
                : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
            }`}
          >
            {filteredImages.map((image, idx) => (
              <div
                key={image.id}
                className="group relative cursor-pointer overflow-hidden rounded-xl shadow-lg"
                onClick={() => setLightboxIndex(idx)}
              >
                <img
                  src={image.image_url}
                  alt={image.title || "Evento"}
                  className="w-full h-56 object-cover transform group-hover:scale-110 transition duration-500"
                />
                {image.title && (
                  <div className="absolute bottom-0 left-0 bg-black/50 text-white p-2 w-full opacity-0 group-hover:opacity-100 transition">
                    <p className="text-sm font-semibold truncate">
                      {image.title}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <Lightbox
        slides={slides}
        open={lightboxIndex >= 0}
        index={lightboxIndex}
        close={() => setLightboxIndex(-1)}
      />
    </div>
  );
};

export default Catalogo;